module.exports = __webpack_public_path__ + "media/images/countryrect/gt-e965e799eda1c3a93280ba57c0155e51.svg";